import { render, staticRenderFns } from "./RadioButtonGroup.vue?vue&type=template&id=66563314&"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports